/**
 * TNWS tag group taxonomy for favorites filtering.
 * HARD-CODED from tag groups.txt — may be replaced later with a dynamic source
 * (e.g. Google Sheet via app proxy or shop metafield).
 *
 * Each product tag is matched case-insensitively against the lists below.
 * Regenerate after editing tag groups.txt: node scripts/build-tag-groups.js
 */
window.TNWS_TAG_GROUPS = {
  "groups": {
    "watch_feature_inputs": [
      "alarm",
      "anti-reflective",
      "automatic movement",
      "Chronograph",
      "date display",
      "deployment clasp",
      "interchangeable strap",
      "limited edition",
      "luminous hands",
      "luminous markers",
      "magnetic resistance",
      "manual winding",
      "moon phase display",
      "multiple time zones",
      "other",
      "perpetual calendar",
      "power reserve indicator",
      "quartz movement",
      "rotating bezel",
      "screw-down crown",
      "shockproof",
      "skeleton dial",
      "solar powered",
      "tachymeter",
      "waterproof",
      "world timer"
    ],
    "thickness": [
      "3mm",
      "4mm",
      "5mm",
      "6mm",
      "7mm",
      "8mm",
      "9mm",
      "10mm",
      "11mm",
      "12mm",
      "13mm",
      "14mm",
      "15mm",
      "16mm",
      "17mm",
      "18mm",
      "19mm",
      "20mm",
      "21mm",
      "22mm",
      "23mm",
      "24mm",
      "25mm",
      "26mm",
      "27mm",
      "28mm",
      "29mm",
      "30mm",
      "31mm",
      "32mm",
      "33mm",
      "34mm",
      "35mm",
      "36mm",
      "37mm",
      "38mm",
      "39mm",
      "40mm",
      "41mm",
      "42mm"
    ],
    "dial_diameter": [
      "5mm",
      "6mm",
      "7mm",
      "8mm",
      "9mm",
      "10mm",
      "11mm",
      "12mm",
      "13mm",
      "14mm",
      "15mm",
      "16mm",
      "17mm",
      "18mm",
      "19mm",
      "20mm",
      "21mm",
      "22mm",
      "23mm",
      "24mm",
      "25mm",
      "26mm",
      "27mm",
      "28mm",
      "29mm",
      "30mm",
      "31mm",
      "32mm",
      "33mm",
      "34mm",
      "35mm",
      "36mm",
      "37mm",
      "38mm",
      "39mm",
      "40mm",
      "41mm",
      "42mm",
      "43mm",
      "44mm",
      "45mm",
      "46mm",
      "47mm",
      "48mm",
      "49mm",
      "50mm",
      "51mm",
      "52mm",
      "53mm",
      "54mm",
      "55mm"
    ],
    "band_size": [
      "6mm",
      "8mm",
      "10mm",
      "11mm",
      "12mm",
      "13mm",
      "14mm",
      "15mm",
      "16mm",
      "17mm",
      "18mm",
      "19mm",
      "20mm",
      "21mm",
      "22mm",
      "23mm",
      "24mm",
      "26mm",
      "28mm",
      "30mm"
    ],
    "brand": [
      "A. Lange & Söhne",
      "AILUO",
      "AKRIVIA",
      "Albishorn",
      "Alexander Shorokhoff",
      "Alpina",
      "Andreas Strehler",
      "Angelus",
      "Angles",
      "Anonimo",
      "Armand Nicolet",
      "Armin Strom",
      "Armitron",
      "Arnold & Son",
      "Ateliers de Monaco",
      "ATOWAK",
      "Audemars Piguet",
      "Auguste Reymond",
      "BA111OD",
      "Backes & Strauss",
      "BALL",
      "Baume & Mercier",
      "Bausele",
      "Behrens",
      "Beijing",
      "Bell & Ross",
      "BENRUS",
      "Bianchet",
      "Bimbu",
      "Blancpain",
      "Bomberg",
      "Breguet",
      "Breitling",
      "Brellum",
      "Bremont",
      "Breva",
      "Briston",
      "Bvlgari",
      "Carl F. Bucherer",
      "Carl Suchy & Söhne",
      "Cartier",
      "Casio",
      "Century",
      "Certina",
      "Chanel",
      "Chopard",
      "Christophe Claret",
      "Chronoswiss",
      "CIGA Design",
      "Citizen",
      "Claude Meylan",
      "Corum",
      "Credor",
      "Cuervo y Sobrinos",
      "Cvstos",
      "Cyrus",
      "Czapek",
      "Daniel Roth",
      "David Candaux",
      "De Bethune",
      "De Rijke & Co.",
      "Delbana",
      "Delma",
      "Doxa",
      "Ebel",
      "Eberhard & Co",
      "EBOHR",
      "Emile Chouriet",
      "Emmanuel Bouchet",
      "F.P.Journe",
      "Fabergé",
      "Favre Leuba",
      "Ferdinand Berthoud",
      "Fiona Krüger",
      "FIYTA",
      "FOD",
      "Fortis",
      "Fossil",
      "Franck Muller",
      "Frederic Jouvenot",
      "Frederique Constant",
      "Furlan Marri",
      "G-SHOCK",
      "GearMagus",
      "Generic",
      "Geneva",
      "Gerald Genta",
      "GEYA",
      "Girard-Perregaux",
      "Glashütte Original",
      "Gorilla",
      "GoS Watches",
      "Graham",
      "Grand Seiko",
      "Greubel Forsey",
      "Grönefeld",
      "H. Moser & Cie",
      "Hajime Asaoka",
      "Hamilton",
      "Hanhart",
      "HAUTLENCE",
      "Hermès",
      "Huasuo",
      "Hublot",
      "Hysek",
      "HYT",
      "Ideal Knight",
      "Ikepod",
      "INVICTA",
      "IWC Schaffhausen",
      "Jacob & Co",
      "Jaeger-LeCoultre",
      "Jaquet Droz",
      "JINLERY",
      "Junghans",
      "KAFYASE",
      "Kenneth Cole",
      "Klokers",
      "Knot",
      "KongShi",
      "Krayon",
      "Kross Studio",
      "Kurono Tokyo",
      "L. Eruditio & Veritas",
      "L. Leroy",
      "Laurent Ferrier",
      "Liang Chen",
      "Linde Werdelin",
      "LOBINNI",
      "Longines",
      "Longio",
      "Lorus",
      "Louis Erard",
      "Louis Moinet",
      "Louis Vuitton",
      "Ludovic Ballouard",
      "Luminox",
      "Lundis Bleus",
      "LYH",
      "Mancheront",
      "Manufacture Royale",
      "Massena LAB",
      "Maurice de Mauriac",
      "Maurice Lacroix",
      "Mauron Musy",
      "MB&F",
      "MeisterSinger",
      "MERKUR",
      "Minase",
      "Montblanc",
      "MOONYANG",
      "Moritz Grossmann",
      "Movado",
      "Naoya Hida",
      "Nivada Grenchen",
      "Nomos Glashütte",
      "NORQAIN",
      "OBLVLO",
      "Omega",
      "OMW",
      "Orient",
      "Orient Star",
      "Oriental Cherry",
      "Oris",
      "OUROBOROS",
      "Panerai",
      "Parmigiani Fleurier",
      "Patek Philippe",
      "Peacock",
      "Pequignet",
      "Perrelet",
      "Piaget",
      "Pierre Paulin",
      "Pole Epoch",
      "Praesidus",
      "Purnell",
      "Q&Q",
      "Rado",
      "Raketa",
      "Ralph Lauren",
      "Raymond Weil",
      "Reef Tiger",
      "Relic",
      "Reservoir",
      "Ressence",
      "Richard Mille",
      "Riskers",
      "Roger Dubuis",
      "Rolex",
      "Romain Gauthier",
      "Rossini",
      "Rumors",
      "SAGA",
      "Sakura",
      "San Martin",
      "Schwarz Etienne",
      "Sea-Gull",
      "Seiko",
      "SEIZENN",
      "SevenFriday",
      "Shanghai",
      "Singer Reimagined",
      "Speake-Marin",
      "Squale",
      "STEELDIVE",
      "STREHLER",
      "Swatch",
      "TAG Heuer",
      "TanZeHua",
      "TAOS",
      "The Citizen",
      "TianWang",
      "Tielbo",
      "Timex",
      "Tissot",
      "Titoni",
      "Trilobe",
      "TUDOR",
      "Tutima Glashütte",
      "U-Boat",
      "Ulysse Nardin",
      "Undone",
      "Universal Genève",
      "Urwerk",
      "Vacheron Constantin",
      "Vager Hauers",
      "Van Cleef & Arpels",
      "Venezianico",
      "Voutilainen",
      "Vulcain",
      "Waltham",
      "Xanadu",
      "YELANG",
      "ZBIOLAND",
      "Zeitwinkel",
      "Zenith",
      "Zodiac",
      "ZRC",
      "ZuanShi"
    ],
    "band_type": [
      "bund strap",
      "chain bracelet",
      "elastic strap",
      "expansion bracelet",
      "fabric strap",
      "integrated metal band",
      "integrated strap",
      "leather strap",
      "mesh bracelet",
      "metal bracelet",
      "nato strap",
      "rubber strap",
      "velcro strap"
    ],
    "wrist_size": [
      "3.00in",
      "3.25in",
      "3.50in",
      "3.75in",
      "4.00in",
      "4.25in",
      "4.50in",
      "4.75in",
      "5.00in",
      "5.25in",
      "5.50in",
      "5.75in",
      "6.00in",
      "6.25in",
      "6.50in",
      "6.75in",
      "7.00in",
      "7.25in",
      "7.50in",
      "7.75in",
      "8.00in",
      "8.25in",
      "8.50in",
      "8.75in",
      "9.00in"
    ],
    "band_sizeable": [
      "No",
      "Yes"
    ],
    "color": [
      "Animal",
      "Beige",
      "Black",
      "Blue",
      "Bronze",
      "Brown",
      "Camouflage",
      "Checkered",
      "Clear",
      "Copper",
      "Dots",
      "Floral",
      "Geometric",
      "Gold",
      "Gray",
      "Green",
      "Multicolor",
      "Navy",
      "Orange",
      "Pink",
      "Plaid",
      "Purple",
      "Rainbow",
      "Red",
      "Rose gold",
      "Silver",
      "Striped",
      "Tie-dye",
      "White",
      "Yellow"
    ],
    "watch_features": [
      "Alarm",
      "Anti-reflective",
      "Automatic movement",
      "Chronograph",
      "Date display",
      "Deployment clasp",
      "Interchangeable strap",
      "Limited edition",
      "Luminous hands",
      "Luminous markers",
      "Magnetic resistance",
      "Manual winding",
      "Moon phase display",
      "Multiple time zones",
      "Other",
      "Perpetual calendar",
      "Power reserve indicator",
      "Quartz movement",
      "Rotating bezel",
      "Screw-down crown",
      "Shockproof",
      "Skeleton dial",
      "Solar powered",
      "Tachymeter",
      "Waterproof",
      "World timer"
    ],
    "significance": [
      "Collector",
      "Limited Edition",
      "Limited Quantity",
      "Modern",
      "Precious Metals",
      "Rare",
      "Vintage"
    ],
    "quality_new_stock": [
      "new stock"
    ],
    "quality_refurbished": [
      "excellent refurbish",
      "good refurbish",
      "poor refurbish"
    ]
  },
  "filters": {
    "brand": [
      "brand"
    ],
    "case": [
      "dial_diameter"
    ],
    "color": [
      "color"
    ],
    "features": [
      "watch_feature_inputs",
      "watch_features"
    ],
    "gender": [],
    "quality": [
      "quality_new_stock",
      "quality_refurbished"
    ]
  }
};
